import { Button, Drawer, Space } from "antd";
import { AiOutlineClose } from "react-icons/ai";

export default function EfficiencyDetails({
  isVisible,
  setShowDetails,
  selected,
}: any) {
  const filtered = selected?.list?.filter(
    (item: any) => item?.hours_taken !== 0
  );

  return (
    <Drawer
      title={`${selected?._id}'s  Efficiency`}
      placement={"right"}
      width={800}
      onClose={() => setShowDetails(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setShowDetails(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="flex py-1 border-b border-gray-300">
          <div className="mr-2 w-8 text-center font-bold">S/N</div>
          <div className="flex justify-between items-center flex-1">
            <div className="font-bold">Name</div>

            <div className="flex">
              <div className="w-20 text-right font-bold">Time Taken</div>
              <div className="w-20 text-right font-bold">Efficiency</div>
            </div>
          </div>
        </div>

        {filtered?.map((item: any, index: number) => (
          <div className="flex py-1  border-b border-gray-300">
            <div className="mr-2">{index + 1}.</div>
            <div className="flex justify-between items-center flex-1">
              <div className="">
                {item.description === " " ? "-" : item.description}
              </div>

              <div className="flex">
                <div className="w-20 text-right">{item.taken}</div>
                <div className="w-20 text-right">
                  {(item.allowed / 3 / item.taken) * 100 > 100
                    ? "100"
                    : ((item.allowed / 3 / item.taken) * 100).toFixed(2)}
                  %
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Drawer>
  );
}
